export interface ConfiguracionSistema {
  moneda: string;
  zonaHoraria: string;
  formatoFecha: string;
  fechaActualizacion: string;
}

export type ConfiguracionSistemaRequest = Omit<ConfiguracionSistema, 'fechaActualizacion'>;

export const DEFAULT_SYSTEM_CONFIG: ConfiguracionSistemaRequest = {
  moneda: 'USD',
  zonaHoraria: 'America/Guayaquil',
  formatoFecha: 'yyyy-MM-dd',
};

export interface EstadoServicio {
  nombre: string;
  estado: string;
  tiempoRespuestaMs: number;
  detalle: string | null;
}

export interface EstadoSistema {
  estado: string;
  verificadoEn: string;
  version: string;
  ambiente: string;
  servicios: EstadoServicio[];
}
